<template>
  <div class="sf-below-3">
    <segment-list
      data-heap="lite-queries-list"
      :segments="segments"
      :loading="loading"
      :test-id="'lite-queries-list'"
      @item-click="selectSegment"
      ><template #static-item>
        <segment-list-item
          :segment="allClientsFakeSegment"
          :loading="loading"
          @item-click="selectAllClients"
        >
        </segment-list-item> </template
    ></segment-list>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SegmentListItem from './segment-list-item.vue'
import SegmentList from './segment-list.vue'
import sharedSegment from '../mixins/shared-segment'

export default {
  components: {
    'segment-list-item': SegmentListItem,
    'segment-list': SegmentList,
  },

  mixins: [sharedSegment],

  computed: {
    ...mapState({
      segments: (state) => state.segments.segments,
      segment: (state) => state.segments.segment,
    }),
    allCompaniesLabel() {
      return I18n.t('segments.modal.all_companies')
    },
    loading() {
      return false
    },
  },

  methods: {
    ...mapActions(['loadSegment', 'unselectSegment']),

    selectSegment(segment) {
      if (!this.segment || this.segment.id !== segment.id) {
        this.loadSegment(segment)
      }
    },
  },
}
</script>
